import SignUpContainer from './SignUpContainer';
import SignUpPage from './SignUpPage';

const SignUp = () => (
    <SignUpContainer.Provider>
        <SignUpPage />
    </SignUpContainer.Provider>
);

export default SignUp;
